import axios from "axios";
import store from "@/store";
import { getBbsToken, getToken } from '@/utils/auth'
import { DialogProgrammatic as Dialog, ToastProgrammatic as Message } from "buefy";
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 100000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    const token = store.getters.getUserToken
    if (token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers.Authorization = "Bearer " + token
    }
    config.headers["Content-Type"] = config.headers['Content-Type'] || "application/json";
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const isNotAuth = !!response.config.notAuth
    const code = response.data.code;
    if (isNotAuth) {
      if (code === 401) {
        store.dispatch("clearToken");
      } else if (code === 400 || code === 403) {
        Dialog.alert(response.data.msg);
        return Promise.reject(response.data.msg);
      }
      return response.data;
    }
    // console.log("response", response);
    if (code === 401) {
      store.dispatch("resetToken");
      if (
        location.href.indexOf("login") !== -1 &&
        location.href.indexOf("logout") !== -1
      ) {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      } else {
        Dialog.alert("请重新登录后访问相关内容");
      }
    } else if (code === 6401) {
      store.dispatch("LogOut");
      Dialog.alert('您的账号登出或登录已过期，请重新登录！')
      // Dialog.confirm({
      //   message: "您的账号登出或登录已过期，请重新登录！",
      //   onConfirm: () => {
      //     // 获取当前页面URL
      //     store.dispatch("LogOut");
      //     const attemptedURL = location.href;
      //     sessionStorage.setItem("attemptedURL", attemptedURL);
      //   },
      // });
    } else if (code === 400 || code === 403) {
      Dialog.alert(response.data.msg);
      return Promise.reject(response.data.msg);
    } else if (code !== 200) {
      Message.open({
        message: response.data.msg,
        type: "is-danger",
      });
      return response.data;
    } else {
      return response.data;
    }
  },
  (error) => {
    if (error.message === "Network Error") {
      Dialog.alert("请求参数错误，请重新登录！" + error.message);
      return;
    }
    Dialog.alert("请确保请求正确的内容");
    return Promise.reject(error);
  }
);

export default service;
